import Slider from 'components/slider';
import Header from 'modules/productDetail/header';
import RemainingTime from 'modules/productDetail/remainingTime';
import Title from 'modules/productDetail/title';
import OfferNumber from 'modules/productDetail/offerNumber';
import Existing from 'modules/productDetail/existing';
import BasePrice from 'modules/productDetail/basePrice';
import Description from 'modules/productDetail/description';
import AddWanted from 'modules/productDetail/addWanted';
import Location from 'modules/productDetail/location';
import Roles from 'modules/productDetail/roles';
import ReportViolation from 'modules/productDetail/reportViolation';
import AddOfferButton from 'modules/productDetail/addOfferButton';
import useSetSliderImages from '../hooks/useSetSliderImages';
import EmptyImage from 'assets/images/noImage/background store 4.svg';
import {toPersianExisting} from 'utilities/helper/toPersianUnits/existing';
import {useState} from 'react';
import AddWantedModal from 'components/modal/wholesaler/addWantedModal';
import AddWantedModalFarm from 'components/modal/farm/addWantedModal';
import CustomBottomSheet from 'components/bottomSheet';
import OfferForm from './form';
import {useParams} from 'react-router-dom';
import Distinguished from '../distinguished';
import {gradeConvertor} from 'components/mainCards/subCardSwitcher/uitilities';

const AuctionDetail = ({post, app, setOpenViolationModal}: IAuctionProps) => {
  const [showModal, setShowModal] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const params = useParams();

  const {sliderImages} = useSetSliderImages({
    mainImage: post.main_image,
    images: post.images,
  });
  return (
    <div className="mt-8 px-3">
      <Header post={post} />
      {sliderImages.length > 1 ? (
        <Slider images={sliderImages} />
      ) : sliderImages.length === 1 ? (
        <img
          alt="slider"
          src={sliderImages[0]}
          className=" block mx-auto w-36"
        />
      ) : (
        <div className="bg-gray-11 w-full flex h-[200px] rounded-lg my-2">
          <img
            alt="empty"
            src={EmptyImage}
            className=" block mx-auto w-36 bg-gray-11"
          />
        </div>
      )}
      <div className="flex items-center">
        <Title title={post.title} />
        {post.grade && (
          <span className="w-[23px]">{gradeConvertor[Number(post.grade)]}</span>
        )}
      </div>
      <RemainingTime remainingTime={post.auction?.expire_date} />
      <OfferNumber offerNumber={post.suggestions} />
      <Existing
        existing={post.existing}
        option={toPersianExisting[post.existing_unit]}
      />
      <BasePrice
        basePrice={
          post.negotiated_price
            ? 'توافقی'
            : `${Number(post.price).toLocaleString()} تومان`
        }
      />
      {post.is_distinguished && (
        <Distinguished date={post.cultivation?.harvest_datetime} />
      )}
      {post.description && <Description description={post.description} />}{' '}
      <AddWanted setShowModal={setShowModal} />
      {post.state && (
        <Location
          location={`${post.state.name} ${
            post.city ? ',' + post.city.name : ''
          }`}
        />
      )}{' '}
      <Roles app={app} />
      <ReportViolation setOpenViolationModal={setOpenViolationModal} />
      <div className="mt-3 pb-12">
        <AddOfferButton
          icon="icon-auction-card"
          setIsOpen={setIsOpen}
          disabled={post?.sale?.is_expired || post.sale_status?.is_saled}
        />
      </div>
      {app === 'market' ? (
        <AddWantedModal
          showModal={showModal}
          setShowModal={setShowModal}
          title={post.title}
          city={post.city && post.city.name}
          state={post.state && post.state.name}
          app={app}
          guid={params.guid}
        />
      ) : (
        <AddWantedModalFarm
          showModal={showModal}
          setShowModal={setShowModal}
          title={post.title}
          city={post.city && post.city.name}
          state={post.state && post.state.name}
          app={app}
          guid={params.guid}
        />
      )}
      <CustomBottomSheet isOpen={isOpen} onDismiss={() => setIsOpen(false)}>
        <>
          <OfferForm setIsOpen={setIsOpen} price={post.price} app={app} />
        </>
      </CustomBottomSheet>
    </div>
  );
};

export default AuctionDetail;
